// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"73fb4b89","885":"8e5d08f0"}[chunkId] + ".chunk.js";
};